module.exports = __webpack_public_path__ + "img/dices.9dfbd488.png";